import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { MessageService } from "primeng/api";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { RestService } from "../../services/rest.service";
import { ToasterService } from "../../services/toaster-service";
import { MessageEnum } from "../../utils/message.enum";
import { ApplicationDetailsActions } from "../actions/application-details.actions";

@Injectable()
export class ApplicationDetailsEffects {
  @BlockUI() blockUI!: NgBlockUI;
  private messageService = inject(MessageService);

  constructor(
    private actions$: Actions,
    private restService: RestService,
    private readonly toaster: ToasterService
  ) {}

  loadApplicationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplicationDetailsActions.loadApplicationDetails),
      mergeMap(({ projectId }) =>
        this.restService.getApplicationDetails(projectId).pipe(
          map((response: any) => {
            this.blockUI.stop();
            const applicationDetails = response?.data;
            return ApplicationDetailsActions.loadApplicationDetailsSuccess({
              applicationDetails,
            });
          }),
          catchError((error) => {
            this.blockUI.stop();
            this.toaster.pop({ type: 'error', text: error});
            return of(
              ApplicationDetailsActions.loadApplicationDetailsFailure({ error })
            );
          })
        )
      )
    )
  );

  updateApplicationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplicationDetailsActions.updateApplicationDetails),
      mergeMap(({ projectId, applicationDetails }) =>
        this.restService
          .updateApplicationsDetails(projectId, applicationDetails)
          .pipe(
            mergeMap((response: any) => {
              this.blockUI.stop();
              this.toaster.pop({ type: 'success', text: MessageEnum.APPLICATION_MAP_SUCCESS });
              const updated = Array.isArray(response?.data)
                ? response.data
                : Array.isArray(response)
                  ? response
                  : applicationDetails;
              return of(
                ApplicationDetailsActions.updateApplicationDetailsSuccess({
                  updatedApplicationDetails: updated,
                }),
                ApplicationDetailsActions.loadSideNavApplications({ projectId })
              );
            }),
            catchError((error) => {
              this.blockUI.stop();
              this.toaster.pop({ type: 'error', text: error });
              return of(
                ApplicationDetailsActions.updateApplicationDetailsFailure({
                  error,
                })
              );
            })
          )
      )
    )
  );

  loadSideNavApplicationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplicationDetailsActions.loadSideNavApplications),
      mergeMap(({ projectId }) =>
        this.restService.getSideNavApplicationDetails(projectId).pipe(
          map((response: any) => {
            this.blockUI.stop();
            const sideNavDetails = response?.data;
            return ApplicationDetailsActions.loadSideNavApplicationsSuccess({
              sideNavDetails,
            });
          }),
          catchError((error) => {
            this.blockUI.stop();
            this.toaster.pop({ type: 'error', text: error });
            return of(
              ApplicationDetailsActions.loadSideNavApplicationsFailure({
                error,
              })
            );
          })
        )
      )
    )
  );
}
